import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="grid h-full place-items-center p-6 text-center">
      <div>
        <p className="text-lg font-medium">{t("notFound.title")}</p>
        <Link className="mt-4 inline-block text-sm underline" to="/">
          {t("notFound.back")}
        </Link>
      </div>
    </div>
  );
}
